var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.getOuterStyle }, [
    _c("div", { staticClass: "label-font" }, [_vm._t("label")], 2),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "icon-left" }, [_vm._t("icon-left")], 2),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "position-relative": !_vm.unPositioned,
            "ios-correct-font-size": _vm.correctIosInputs
          }
        },
        [
          _vm._t("input", null, { params: _vm.getExposedParams }),
          _vm._v(" "),
          _c("div", { staticClass: "footnote" }, [_vm._t("footnote")], 2),
          _vm._v(" "),
          _vm.showErrorIcon
            ? _c("div", { class: { "input-error": true } }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover",
                        modifiers: { hover: true }
                      }
                    ],
                    staticClass: "msg",
                    attrs: { title: _vm.$t(_vm.getErrorMessage) }
                  },
                  [
                    _c("icon", {
                      attrs: { width: "100%", name: "exclamation-circle" }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "icon-right" }, [_vm._t("icon-right")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70bb4054", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70bb4054","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/input/InputBase.vue
// module id = null
// module chunks = 